export default "/images/b542c7b2b9cab28d1257466b0b3f78d3.avif";